import { pick } from 'lodash';

export type DataAttributes = Record<string, unknown>;

/**
 * @pickDataAttributes filters the "data-..." atributes from the props object
 *
 * @param {object} props Object to filter through
 * @param {string | undefined} componentName The component name
 * @returns {DataAttributes} Object with all properties that contain `data-`
 */

export const pickDataAttributes = (props: object, componentName?: string): DataAttributes => {
  // @ts-ignore
  const dataAttributes: DataAttributes = pick(
    props,
    Object.keys(props).filter(prop => prop.includes('data-'))
  );

  // Assign default data attribute if passed component name
  if (!dataAttributes['data-component-type'] && componentName) {
    dataAttributes['data-component-type'] = componentName;
  }

  return dataAttributes;
};
